import { createFileRoute } from "@tanstack/react-router";

import { MarketsPage } from "@/features/administration/pages";

/** The markets and the windows a visit is booked into there. */
export const Route = createFileRoute("/_app/settings/markets")({
  component: MarketsPage,
});
